import React from "react";

import PropTypes from 'prop-types';

export default class StickyFooter extends React.Component {
  render() {
    return (
      <div className="sticky-footer">
        <div className="sticky-footer__container container">
          <div data-test-id="sticky-footer-children">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

StickyFooter.propTypes = {
  children: PropTypes.node.isRequired
};
